module.exports = __webpack_public_path__ + "img/modularidade.259a9097.png";